import { useTranslator } from '@picsart/rc/services/localization';
import { Badge, BadgeSizeMD, BadgeTypes } from '@picsart/badge';
import { Placements, Tooltip } from '@picsart/tooltip';
import { memo } from 'react';

import { ProBadgeProps } from './types';
import useStyles from './styles';

const ProBadge = ({ className }: ProBadgeProps) => {
  const translate = useTranslator();
  const classes = useStyles();

  return (
    <div className={className}>
      <Tooltip
        placement={Placements.Bottom}
        className={classes.tooltip}
        target={(
          <Badge variant={BadgeTypes.Pro} size={BadgeSizeMD} />
        )}
      >
        {translate('This is a premium texture')}
      </Tooltip>
    </div>
  );
};

export default memo(ProBadge);
